import React,{useEffect, useState} from 'react'
import StarRatings from 'react-star-ratings';
import { BrowserRouter as Router,NavLink,useLocation,useHistory} from 'react-router-dom';
import "./AllListing.css"
import { getBusiness } from '../../Services/business.service';
import b1 from "../../assets/images/b1.jpg"
import b2 from "../../assets/images/b2.jpg"
import profile1 from "../../assets/images/profile1.jpg"

export function AllListing() {
    const [perviousData,setperviousData] = useState();
    useEffect(()=>{
     
       
        setperviousData();
        getBusiness().then((res)=>{
            setperviousData(res);
            console.log('business Array on All Listing is',res);
            

        });        
      
    },[]);
    let [state,setState]=useState({
        
    })

   function handleChange(event) {
        setState({
          [event.target.name]: event.target.value
        });
        console.log(event.target.name);
        console.log(event.target.value);
      }
    return(
        <>

            {
                typeof perviousData === 'undefined'?<h1>Geting the data ready.....</h1>:
                <div className="allListingPage">
            <section className="container">
                <div className="filterDiv">
                    <p className="mb-0 mr-3">Filter by</p>
                    <div className="form-group firstFilter">
                       <input type="text" placeholder="business name" className="form-control" />
                    </div>
                    <div className="form-group mb-0">
                       <input type="text" placeholder="city" className="form-control" />
                    </div>
                </div>
            </section>
            <section className="container">
                <div className="sortyByDiv">
                    <div className="form-group">
                        <select className="form-control" placeholder="Sort by" onChange={(e)=>handleChange} name="filter" value={state.filter} aria-label="Default select example">
                            <option selected disabled>Sort by</option>
                            <option value="Newest">Newest</option>
                            <option value="Oldest">Oldest</option>
                            <option value="highestrating">Highest Rating</option>
                            <option value="lowestrating">Lowest Rating</option>
                        </select>
                    </div>
                </div>
            </section>
            <section className="container most-review mt-5">
                <div className="row">
                {
                    typeof perviousData === 'undefined'?<>Loading data ....</>:perviousData.map((item,index)=>
                        <div className="col-lg-4 col-md-6 mb-3" key={index}>
                        <BusinessCard name={item.name} cover={item.coverPhotoURL} address={item.address} contact={item.phoneNumber} rating={item.businessCount%5} logo={item.logoURL} to={item.businessId}/>
                       </div>  
                    )
                    
                }                  
              </div>    
            </section>
        </div>
       }
        </>
    )
}
const BusinessCard=(props)=>{

    let {name,address,contact,rating,logo,to,cover}=props
     rating=parseFloat(rating)

    return(
      
        <NavLink className="businessCard" to={`/description/${to}`}>
        <div className="imgDiv">
            <img src={cover} alt="cover" />
            <div className="textDiv">
                <h4 className="mb-3">{name}</h4>
                <div><address>{address}</address></div>
                <div className="phone"><i class="fa fa-phone" aria-hidden="true"></i> {contact}</div>
            </div>
        </div>
        <div className="ratingDiv">
            <div className="">
            <StarRatings
            rating={rating}
            starDimension="18px"
            starSpacing="1px"
            numberOfStars={5}
            starRatedColor="orange"
        />
            </div>
            <div className="profileDiv"><img src={logo} alt="" /></div>
        </div>
    </NavLink>

    )
}